import type { AwarenessData } from '@/types'

interface AwarenessBarProps {
  data: AwarenessData | null
}

export default function AwarenessBar({ data }: AwarenessBarProps) {
  if (!data) return null

  const levelColors = {
    success: 'bg-[var(--bac-safe)] text-white',
    warning: 'bg-[var(--bac-caution)] text-[var(--bg-primary)]',
    danger: 'bg-[var(--bac-danger)] text-white',
    dark: 'bg-[var(--bac-critical)] text-white',
  }

  const levelIcons = {
    success: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
      </svg>
    ),
    warning: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
    ),
    danger: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    dark: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
    ),
  }

  return (
    <div className={`rounded-lg px-4 py-3 flex items-start gap-3 ${levelColors[data.level]}`}>
      <span className="flex-shrink-0 mt-0.5">{levelIcons[data.level]}</span>
      <div className="flex-1">
        <p className="font-medium">{data.message}</p>
        <p className="text-sm opacity-80 mt-1">
          Current: {data.currentBac.toFixed(3)}% • Avg peak: {data.avgPeakBac.toFixed(3)}% • Last peak: {data.lastSessionPeakBac.toFixed(3)}%
        </p>
      </div>
    </div>
  )
}
